import React from 'react';
import { Container } from 'react-bootstrap';
import {AccountForm} from "./index";

const EditAccount = () => {
    return (
        <Container fluid className="p-0">
            <AccountForm isEdit={true} />
        </Container>
    );
};

export default EditAccount;
